import Vue from 'vue'
import Vuex from 'vuex'
import { initPlugin } from '../utils/jyPlugin'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    link_able: true,
    params: {},
    user: {},
    logined: 'wait',
    env: null,
    captchaInfo: {},
    codeToken: null
  },
  mutations: {
    STATE_UPDATE (state, e) {
      Object.keys(e).forEach(key => {
        if (e[key] || e[key] === false) {
          state[key] = JSON.parse(JSON.stringify(e[key]))
        }
      })
    },
    SET_CAPTCHA_INFO (state, data) {
      state.captchaInfo = data
    },
    SET_CODE_TOKEN (state, data) {
      state.codeToken = data
    }
  },
  actions: {
    state_update ({ commit }, e) {
      commit('STATE_UPDATE', e)
    },
    async initPlugin ({ commit }, data) {
      const captchaObj = await initPlugin()

      if (!captchaObj) return

      // 处理初始化完成后 执行verify无效的问题
      await new Promise((resolve, reject) => {
        setTimeout(() => resolve(true), 600)
      })

      commit('SET_CAPTCHA_INFO', captchaObj)
      
      return captchaObj
    }
  }
})
